import { Team, Member, Award } from './models'
import supportsWebP from 'supports-webp'

import teamList from './assets/api/team-list-1.json'
import teamMembers from './assets/api/team-members-1.json'
import teamAwards from './assets/api/team-awards-1.json'

const indexMapping = new Map(teamList.map((team, id) => [team.id, id]))

export async function getTeamsList(contestId: number = 1): Promise<Team[]> {
    return contestId === 1 ? teamList : [];
}

export async function getTeamMembers(teamId: number): Promise<Member[]> {
    return teamMembers[indexMapping.get(teamId)!]
}

export async function getTeamAwardsPartcipated(teamId: number): Promise<Award[]> {
    return teamAwards[indexMapping.get(teamId)!]
}

export async function teamAvatarUrl(teamId: number) {
    const { default: teamAvatars } = !await supportsWebP
        ? await import('./assets/api/team-avatars-1.json')
        : await import('./assets/api/team-avatars-webp-1.json')
    return teamAvatars[indexMapping.get(teamId)!]
}

export function userAvatarUrl(userId: string) {
    return `https://crafatar.com/avatars/${userId}?size=64&overlay`
}